import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import Navigation from './components/Navigation';
import Home from './pages/index';
import About from './pages/about';
import Projects from './pages/projects';
import CaseStudies from './pages/case-studies';
import Contact from './pages/contact';
import Services from './pages/services';
import theme from './theme';

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      <Navigation />
      <Box
        component="main"
        sx={{
          // On mobile, add top padding so fixed nav doesn’t cover hero/content (except on home)
          pt: { xs: isHomePage ? 0 : 5, md: 0 },
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Box>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
